module.exports = __webpack_public_path__ + "static/media/china-high-speed-line-cover.74fcbcf6.webp";